export default {
    FIELD_ERRORS: 'FIELD_ERRORS',
}